// Support domain types — mirrors SupportTicketResource, SupportMessageResource,
// SupportAttachmentResource, and SupportUnreadCountResource from the backend.

export const SupportTicketStatus = {
  New: 'new',
  Ongoing: 'ongoing',
  WaitingForReply: 'waiting_for_reply',
  Closed: 'closed',
} as const

export type SupportTicketStatus = typeof SupportTicketStatus[keyof typeof SupportTicketStatus]

export const SupportTicketCategory = {
  TechnicalIssue: 'technical_issue',
  RegistrationProblem: 'registration_problem',
  BillingAndPayments: 'billing_and_payments',
  AccountAndProfile: 'account_and_profile',
  GeneralQuestion: 'general_question',
  FeatureRequest: 'feature_request',
} as const

export type SupportTicketCategory = typeof SupportTicketCategory[keyof typeof SupportTicketCategory]

export const SupportMessageAuthorType = {
  Organizer: 'organizer',
  Staff: 'staff',
} as const

export type SupportMessageAuthorType = typeof SupportMessageAuthorType[keyof typeof SupportMessageAuthorType]

export interface SupportAttachment {
  id: number
  original_filename: string
  mime_type: string
  size_bytes: number
  url: string // signed, short-lived; do not cache
}

export interface SupportMessage {
  id: number
  author_type: SupportMessageAuthorType
  author_name: string | null
  body: string // markdown source
  attachments: SupportAttachment[]
  created_at: string
}

export interface SupportTicket {
  id: number
  organisation_id: number
  category: SupportTicketCategory
  subject: string
  status: SupportTicketStatus
  unread_by_organisation: boolean
  message_count: number
  last_message_author_type: SupportMessageAuthorType | null
  last_activity_at: string
  closed_at: string | null
  created_at: string
  messages?: SupportMessage[] // present only on the show endpoint
}

export interface StoreSupportTicketPayload {
  category: SupportTicketCategory
  subject: string
  body: string
  attachment_ids?: number[]
}

export interface StoreSupportMessagePayload {
  body: string
  attachment_ids?: number[]
}

export interface AttachmentUpload {
  tempId: string
  file: File
  status: 'uploading' | 'done' | 'error'
  attachmentId?: number
}

export type SupportTicketFilter = 'all' | 'open' | 'waiting' | 'closed'
